<template>
    <div>
        <el-dialog
        title="修改密码"
        :visible.sync="centerDialogVisible_pwd"
        width="30%"
        @close="dialogClose('ruleForm')"
        center>

            <div>
                <el-form :model="ruleForm" status-icon :rules="rules_newPwd" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="旧密码" prop="pwd">
                        <el-input type="password" v-model="ruleForm.pwd" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="密码" prop="pass">
                        <el-input type="password" v-model="ruleForm.pass" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="checkPass">
                        <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="handleEditPwd">提交</el-button>
                        <el-button @click="resetForm('ruleForm')">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>


        </el-dialog>
    </div>
</template>

<script>
    import {myMixin} from '@/mixin.js';
    export default {
        mixins: [myMixin],
        data() {

            var validatePass = (rule, value, callback) => {
              var reg = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[\W_]).{8,32}$/;
              if (value === '') {
                callback(new Error('请输入密码'));
              } else if(!reg.test(value)){
                callback(new Error('密码必须是8-32位字符，且包含字母、数字、特殊符号'));
              }else {
                if (this.ruleForm.checkPass !== '') {
                  this.$refs.ruleForm.validateField('checkPass');
                }
                callback();
              }
            };
            var validatePass2 = (rule, value, callback) => {
              var reg = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[\W_]).{8,32}$/;
              if (value === '') {
                callback(new Error('请输入确认密码'));
              } else if (value !== this.ruleForm.pass) {
                callback(new Error('两次输入密码不一致!'));
              } else if(!reg.test(value)){
                callback(new Error('密码必须是8-32位字符，且包含字母、数字、特殊符号'));
              } else {
                callback();
              }
            };
            var validatePass3 = (rule, value, callback) => {
              var reg = /^.{8,32}$/;
              if (value === '') {
                callback(new Error('请输入旧密码'));
              } else if(!reg.test(value)){
                callback(new Error('旧密码是8-32位字符'));
              } else {
                callback();
              }
            };

            return {
                centerDialogVisible_pwd: false,
                rules_newPwd: {
                    pass: [//请输入密码
                        { required: true,validator: validatePass, trigger: 'blur' }
                    ],
                    checkPass: [//请再次输入密码
                        { required: true,validator: validatePass2, trigger: 'blur' }
                    ],
                    pwd: [//请输入旧密码
                        { required: true,validator: validatePass3, trigger: 'blur' },
                    ]
                },
                ruleForm: {
                    pass: '',
                    checkPass: '',
                    pwd: ''
                },
            }
        },
        methods: {
            open(){
                this.centerDialogVisible_pwd = true;
            },
            //修改密码
            handleEditPwd(){
                this.submitForm('ruleForm')
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$emit("handleEditPwdClick",this.ruleForm);
                    this.centerDialogVisible_pwd = false;
                } else {
                    console.log('error submit!!');
                    return false;
                }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/login/newpwd.vue